var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9,
    cx: 18.9993,
    cy: 18.3216,
    r: 18.222,
    fill: "#ECEAF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3899 9.06689C20.6174 9.06689 21.7947 9.55454 22.6627 10.4226C23.5307 11.2906 24.0184 12.4679 24.0184 13.6954C24.0184 14.923 23.5307 16.1003 22.6627 16.9683C21.7947 17.8363 20.6174 18.3239 19.3899 18.3239C18.1623 18.3239 16.985 17.8363 16.117 16.9683C15.249 16.1003 14.7613 14.923 14.7613 13.6954C14.7613 12.4679 15.249 11.2906 16.117 10.4226C16.985 9.55454 18.1623 9.06689 19.3899 9.06689ZM19.3899 20.6382C24.5044 20.6382 28.6469 22.7095 28.6469 25.2667V27.581H10.1328V25.2667C10.1328 22.7095 14.2753 20.6382 19.3899 20.6382Z",
    fill: "#424952",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserImg);
export default __webpack_public_path__ + "static/media/userImg.d250b89ad1e61b0428fe2c32e56d5d54.svg";
export { ForwardRef as ReactComponent };